export const CANONICAL_ORIGIN = "https://lookwashington.com";

export const canonicalUrl = (path) =>
  path === "/" ? `${CANONICAL_ORIGIN}/` : `${CANONICAL_ORIGIN}${path}`;

const PAGES = [
  {
    canonical: "/",
    aliases: [],
    title: "THE WALL — Driven by Sound",
    description:
      "A civic and cultural platform for the South Sound — local businesses, community events, the Tacoma Santa Parade, and the artists who light it all up.",
  },
  {
    canonical: "/about",
    aliases: [],
    title: "About · THE WALL",
    description:
      "What THE WALL is, who builds it, and why we champion Washington's 501(c)(3) organizations, local businesses, and working artists.",
  },
  {
    canonical: "/resources",
    aliases: [],
    title: "Resource Library · THE WALL",
    description:
      "A curated library of community resources for the South Sound — safety information, support services, and local knowledge.",
  },
  {
    canonical: "/community-hub",
    aliases: ["/communityhub", "/maps-calendars"],
    title: "Community Hub · THE WALL",
    description:
      "Community calendar, area maps, and local gems for Tacoma and the South Sound — all in one place.",
  },
  {
    canonical: "/for-bands",
    aliases: [],
    title: "For Bands · THE WALL",
    description:
      "A visual, musician-friendly onboarding portal for bands and artists — tour pages, promotion, and community support on THE WALL.",
  },
  {
    canonical: "/holiday-hope-hop",
    aliases: ["/holiday-hop", "/hop"],
    title: "Holiday HOPE HOP · THE WALL",
    description:
      "The Tacoma Joy Trail — a holiday hop across local businesses spreading hope, joy, and community spirit in the South Sound.",
  },
  {
    canonical: "/events",
    aliases: [],
    title: "Community Calendar · THE WALL",
    description:
      "Upcoming community events, live music, and gatherings across Tacoma and the South Sound.",
  },
  {
    canonical: "/music",
    aliases: [],
    title: "Music Hub · THE WALL",
    description:
      "The South Sound music scene — live shows, venues, and the local artists who keep the region loud.",
  },
  {
    canonical: "/art",
    aliases: [],
    title: "Art · THE WALL",
    description:
      "Local art, artists, and creative happenings across Tacoma and the South Sound.",
  },
  {
    canonical: "/artists",
    aliases: [],
    title: "Artists & Bands · THE WALL",
    description:
      "Discover South Sound artists and touring bands — profiles, tour dates, music links, and how to support them.",
  },
  {
    canonical: "/map",
    aliases: [],
    title: "Area Maps · THE WALL",
    description:
      "Interactive maps of organizations, businesses, and community resources across Washington's South Sound.",
  },
  {
    canonical: "/deals",
    aliases: [],
    title: "Local Deals · THE WALL",
    description:
      "Deals and offers from South Sound businesses that support their community.",
  },
  {
    canonical: "/trove-guide",
    aliases: [],
    title: "Hoard Guide · THE WALL",
    description:
      "How the Hoard works — donate to Washington 501(c)(3) organizations and discover treasures from local businesses.",
  },
  {
    canonical: "/origins",
    aliases: [],
    title: "Origins · THE WALL",
    description: "The story behind THE WALL and how it came to serve the South Sound.",
  },
  {
    canonical: "/get-involved",
    aliases: [],
    title: "Get Involved · THE WALL",
    description:
      "Volunteer, partner, donate, or contribute — ways to help THE WALL support the South Sound community.",
  },
  {
    canonical: "/tacoma-santa-parade",
    aliases: ["/santa-parade", "/santaparade"],
    title: "Tacoma Santa Parade · THE WALL",
    description:
      "The Tacoma Santa Parade — route, dates, and how to join the South Sound's most joyful tradition.",
  },
  {
    canonical: "/gig-harbor",
    aliases: ["/gigharbor"],
    title: "Gig Harbor Guide · THE WALL",
    description:
      "A local guide to Gig Harbor — businesses, events, and community gems on the water.",
  },
  {
    canonical: "/tacoma/6th-ave",
    aliases: ["/6thave", "/sixthave"],
    title: "6th Ave District, Tacoma · THE WALL",
    description:
      "A guide to Tacoma's 6th Ave district — venues, restaurants, shops, and the culture that keeps the avenue alive.",
  },
  {
    canonical: "/tacoma/south-tacoma-way",
    aliases: ["/stw", "/tacoma/stw"],
    title: "South Tacoma Way · THE WALL",
    description:
      "A guide to South Tacoma Way — local businesses, history, and hidden gems along Tacoma's classic strip.",
  },
  {
    canonical: "/tacoma/parks",
    aliases: ["/parks"],
    title: "Tacoma Parks · THE WALL",
    description:
      "Parks and green spaces around Tacoma — where the community gathers, plays, and breathes.",
  },
];

const LOOKUP = {};
for (const page of PAGES) {
  LOOKUP[page.canonical.toLowerCase()] = page;
  for (const alias of page.aliases) LOOKUP[alias.toLowerCase()] = page;
}

export const getRouteMeta = (pathname) => {
  const key = (pathname || "/").toLowerCase().replace(/\/+$/, "") || "/";
  return LOOKUP[key] || null;
};
